import { FormItemsGroup } from '@billy/design-system'
import { ReactElement } from 'react'

import { CustomerType } from '@features/contacts/enums/customerType'
import { useInvoiceComplianceMode } from '@features/invoices/hooks/useInvoiceComplianceMode'

import { useMissingCustomerDetailsForm } from '../../../../contexts/missingCustomerDetailsFormContext'
import { CustomerCompanyName } from './elements/CustomerCompanyName'
import { CustomerFirstName } from './elements/CustomerFirstName'
import { CustomerLastName } from './elements/CustomerLastName'

export const CustomerNameSection = (): ReactElement => {
  const {
    missingCustomerDetailsForm: { watch },
  } = useMissingCustomerDetailsForm()
  const { isFrenchComplianceMode } = useInvoiceComplianceMode()

  const customerType = watch('customerType')
  const isIndividualCustomer = customerType === CustomerType.Individual
  const shouldShowIndividualCustomerFields = isIndividualCustomer && isFrenchComplianceMode

  if (shouldShowIndividualCustomerFields) {
    return (
      <FormItemsGroup itemsInRow={2}>
        <CustomerFirstName />
        <CustomerLastName />
      </FormItemsGroup>
    )
  }

  return <CustomerCompanyName />
}
